<script>import { stateUiTimerCount, stateUiTimerFrom } from "@infinitro/global";
import { derived } from "svelte/store";
const percentage = derived(
  [stateUiTimerFrom, stateUiTimerCount],
  ([$stateUiTimerFrom, $stateUiTimerCount]) => $stateUiTimerCount / $stateUiTimerFrom * 100
);
const borderBottomWidth = derived(
  percentage,
  ($percentage) => $percentage > 75 ? `${($percentage - 75) * 4}%` : "0%"
);
const borderRightHeight = derived(
  percentage,
  ($percentage) => $percentage > 75 ? "100%" : $percentage > 50 ? `${($percentage - 50) * 4}%` : "0%"
);
const borderTopWidth = derived(
  percentage,
  ($percentage) => $percentage > 50 ? "100%" : $percentage > 25 ? `${($percentage - 25) * 4}%` : "0%"
);
const borderLeftHeight = derived(
  percentage,
  ($percentage) => $percentage > 25 ? "100%" : `${$percentage * 4}%`
);
</script>

{#if $stateUiTimerCount > 0}
	<div class="timer-container">
		<div class="timer">
			<span class="timer-text">{$stateUiTimerCount}s</span>
		</div>
		<div
			class="timer-border timer-border-bottom"
			style="width: {$borderBottomWidth}; right: 0;"
		></div>
		<div
			class="timer-border timer-border-right"
			style="height: {$borderRightHeight}; top: 0;"
		></div>
		<div class="timer-border timer-border-top" style="width: {$borderTopWidth}; left: 0;"></div>
		<div
			class="timer-border timer-border-left"
			style="height: {$borderLeftHeight}; bottom: 0;"
		></div>
	</div>
{/if}

<style>
	.timer-container {
		position: relative;
		display: flex;
		height: 40px;
		width: 40px;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		border-radius: 8px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity));
		background: var(--gradient-main)
}

	.timer {
		position: relative;
		z-index: 10;
		display: flex;
		height: 36px;
		width: 36px;
		align-items: center;
		justify-content: center;
		border-radius: 6px;
		background: var(--gradient-main)
}

	.timer-text {
		position: relative;
		font-size: 16px;
		z-index: 1
}

	.timer-border {
		position: absolute;
		border-radius: 0.5rem;
		background-color: var(--color-primary-500);
		transition:
			width 0.5s,
			height 0.5s
}

	.timer-border-bottom {
		bottom: 0px;
		height: 0.375rem
}

	.timer-border-right {
		right: 0px;
		width: 0.375rem
}

	.timer-border-top {
		top: 0px;
		height: 0.375rem
}

	.timer-border-left {
		left: 0px;
		width: 0.375rem
}
</style>
